$ = require 'jquery'
Confirm = require 'app/scripts/views/lib/confirm'
PopOver = require 'app/scripts/views/lib/pop-over'
ReopenBoardPopoverView = require 'app/scripts/views/board/reopen-board-popover-view'
ModelLoader = require 'app/scripts/db/model-loader'
Promise = require 'bluebird'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
{ track } = require '@trello/analytics'
t = require('app/scripts/views/internal/teacup-with-helpers')('archive_item')
l = require 'app/scripts/lib/localize'
Auth = require 'app/scripts/db/auth'
Confirm = require 'app/scripts/views/lib/confirm'
template = require 'app/scripts/views/templates/archive_item'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class ArchivedModelView extends View
  tagName: 'li'

  className: 'u-clearfix'

  events:
    'click .js-reopen': 'reopen'
    'click .js-delete': 'delete'
    'click .js-leave': 'leaveConfirm'

  initialize: ->
    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)
    @me = Auth.me()
    @listenTo @model, 'deleting', @render
    if @model.getBoard?
      @listenTo @model.getBoard(), 'change:limits', @render

  _checkTargetCapacity: ->
    # This function doesn't handle cards,
    # but this view isn't used for cards currently
    result = true
    if @model.getBoard?
      # Check for capacity on the target board (Lists and Cards)
      result = @model.getBoard().hasCapacity(@model)

    result

  canReopen: ->
    targetHasCapacity = @_checkTargetCapacity()
    if @model.owned?
      targetHasCapacity && @model.owned()
    else
      targetHasCapacity && @model.editable()

  canDelete: ->
    @model.owned?()

  canLeave: ->
    @model.owned? && !@model.owned()

  render: ->
    @$el.html template({
      name: @model.get('name')
      orgName:
        if org = @model.getOrganization()
          org.get('displayName')
        else if @model.hasOrganization()
          l(['templates', 'board_header', 'private-team'])
        else
          l('personal')
      url: @model.getUrl?()
      reOpenText: @options.reOpenText
      canDelete: @canDelete()
      canReopen: @canReopen()
      canLeave: @canLeave()
      deleting: @model.isDeleting?()
      reopenDisabled: @options.reopenDisabled
    })

    @

  reopen: (e) ->
    Util.stop(e)
    org = @model.getOrganization()
    return if org?.isAtOrOverFreeBoardLimit()

    # Ensure we have all the data needed for the board popover
    promises = [@model.getNewBillableGuests()]
    if(org && (!org.adminList || org.adminList.length == 0))
      promises.push(ModelLoader.loadOrganizationMembersMinimal org.id)

    # Check if re-opening this board would result in any newly billable guests,
    # and if so, show the confirmation popover
    Promise.all(promises).then ([args]) =>
      { newBillableGuests, availableLicenseCount } = args
      if newBillableGuests.length > 0
        PopOver.show
          elem: @$('.js-reopen')
          view: new ReopenBoardPopoverView {
            board: @model,
            org,
            newBillableGuests,
            availableLicenseCount,
            onReopen: =>
              track(@model.typeName, "Reopen", "Via Archive")
              if @sendGASEvent
                Analytics.sendTrackEvent
                  action: 'reopened',
                  actionSubject: 'board',
                  source: 'closedBoardsScreen',
                  containers:
                    board:
                      id: @model.id
          }
      else
        @model.reopen()
        track(@model.typeName, "Reopen", "Via Archive")
        if @sendGASEvent
          Analytics.sendTrackEvent
            action: 'reopened',
            actionSubject: 'board',
            source: 'closedBoardsScreen',
            containers:
              board:
                id: @model.id

  delete: (e) ->
    Util.stop(e)

    Confirm.toggle 'delete board',
      elem: e.target
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.startDelete()
        .then =>
          track("Board", "Delete", "Via Closed Boards List")
          if @sendGASEvent
            Analytics.sendTrackEvent
              action: 'deleted',
              actionSubject: 'board',
              source: 'closedBoardsScreen',
              containers:
                board:
                  id: @model.id
        .done()

  leaveConfirm: (e) ->
    Util.stop(e)

    track("Closed Boards", "Open Leave Menu")
    if @sendGASEvent
      Analytics.sendUIEvent
        action: 'clicked',
        actionSubject: 'menu',
        source: 'leaveBoardMenu',
        containers:
          board:
            id: @model.id

    key = @me.removeMembershipConfirmationKey(@model)

    Confirm.toggle key,
      elem: $(e.target).closest('a')
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.removeMember(@me)
        track("Board", "Leave Board", "Via Closed Boards List")
        if @sendGASEvent
          Analytics.sendTrackEvent
            action: 'left',
            actionSubject: 'board',
            source: 'closedBoardsScreen',
            containers:
              board:
                id: @model.id

    return
